import { render } from "./VideoCard.vue?vue&type=template&id=2f263176&scoped=true&ts=true"
import script from "./videoCardHelper.ts?vue&type=script&lang=ts"
export * from "./videoCardHelper.ts?vue&type=script&lang=ts"

import "./VideoCard.vue?vue&type=style&index=0&id=2f263176&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f263176"]])

export default __exports__